<template>
  <div>
    <base-material-card color="secondary" icon="mdi-note-text-outline" :title="$t('manage_category')"><v-container>
        <v-row>
          <v-col cols="12">
            <div style="float: left; margin-right: 20px">
              <v-btn icon color="green" large @click="goBack()">
                <v-icon>mdi-arrow-left-circle</v-icon>
              </v-btn>
              {{ $t("back") }}

              <v-btn icon color="primary" large style="float: right" @click="loadGara()">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn small class="mx-2" @click="editRoutine()" color="primary">{{ $t("create_category") }}</v-btn>
            </div>
            <v-autocomplete v-model="selectedSettore" :items="listSettori" item-text="text" item-value="value"
              @change="loadGara" dense :label="$t('select_sector')"></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <DataTables :headers="headers" itemKey="idGareDettaglio" :expandFields="['txtPartecipantiRagSoc']"
              :tableData="tableData" @editRoutine="editRoutine" @editGaraPartecipanti="editGaraPartecipanti">
            </DataTables>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>

    <base-dialog-form ref="editRoutineDialog" :title="method === 'ADD' ? this.$t('create_category') : this.$t('edit_category')
      " height="90vh" :text="method === 'ADD' ? '' : currentRoutine.titolo" color="secondary"
      icon="mdi-format-list-bulleted-type">
      <template v-slot:actions>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" @click="saveRoutine" color="success">{{
            method === "ADD" ? $t("create") : $t("save")
          }}</v-btn>

          <v-btn class="mx-5" v-if="method === 'EDIT'" @click="deleteRoutine" color="error">{{
            $t("delete")
          }}</v-btn></v-col>
      </template>
      <v-container>
        <v-row>
          <v-col md="4" cols="12">
            <v-text-field v-model="currentRoutine.settore" :label="$t('sector')" :rules="required" hide-details="auto">
            </v-text-field>
          </v-col>
          <v-col md="2" cols="12">
            <v-text-field v-model="currentRoutine.classe" :label="$t('class')" :rules="required" hide-details="auto">
            </v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field v-model="currentRoutine.disciplina" :label="$t('match_sport')" :rules="required"
              hide-details="auto">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" cols="12">
            <v-text-field v-model="currentRoutine.titolo" :label="$t('title')" :rules="required" hide-details="auto">
            </v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field v-model="currentRoutine.categoria" :label="$t('category')" :rules="required"
              hide-details="auto">
            </v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-autocomplete v-model="currentRoutine.listGiudiciGaraId" :items="listUsers" item-text="text"
              item-value="value" dense multiple chips :label="$t('giudice_point')"></v-autocomplete>
          </v-col>
          <v-col md="6" cols="12">
            <v-autocomplete v-model="currentRoutine.listGiudiciPenalitaId" :items="listUsers" item-text="text"
              item-value="value" dense multiple chips :label="$t('giudice_penalty')"></v-autocomplete>
          </v-col>
          <v-col md="6" cols="12">
            <v-autocomplete v-model="currentRoutine.idScheda" :items="listSchede"
              :label="$t('evaluation_table')"></v-autocomplete>
          </v-col>
          <v-col md="3" cols="6">
            <v-select v-model="currentRoutine.type" :items="[
              { key: 'P', text: $t('type_vote') },
              { key: 'T', text: $t('type_time') },
            ]" :label="$t('type')" item-text="text" item-value="key" color="primary"></v-select>
          </v-col>
          <v-col md="3" cols="6">
            <v-select v-model="currentRoutine.mode" :items="[
              { key: 'I', text: $t('mode_individual') },
              { key: 'T', text: $t('mode_team') },
            ]" :label="$t('mode')" item-text="text" item-value="key" color="primary"></v-select>
          </v-col>
        </v-row>
      </v-container>
    </base-dialog-form>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import DataTables from "@/components/base/DataTables.vue";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import MyTimepicker from "@/components/base/MyTimepicker.vue";

export default {
  name: "gest-gara-dettaglio",

  components: {
    DataTables,
    MyDatepicker,
    MyTimepicker,
  },
  props: {
    idGara: null,
  },
  data() {
    return {
      headers: [
        { text: this.$t("N°"), value: "ordine" },
        { text: this.$t("routine"), value: "listRoutine" },
        { text: this.$t("date"), value: "dateInz", type: "datetime" },
        { text: this.$t("type"), value: "iconType", type: "icons" },
        { text: this.$t("class"), value: "classe" },
        { text: this.$t("category"), value: "categoria" },
        { text: this.$t("discipline"), value: "disciplina" },
        { text: this.$t("title"), value: "titolo" },
        {
          text: this.$t("giudice_point"),
          value: "nameGiudiciGara",
          type: "html",
        },
        {
          text: this.$t("giudice_penalty"),
          value: "nameGiudiciPenalita",
          type: "html",
        },
        { text: this.$t("evaluation_table"), value: "schedaValutazione" },
        { text: this.$t("tot_subscribers"), value: "totPartecipanti" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      method: null,
      tableData: [],
      listSchede: [],
      listSettori: [],
      selectedSettore: null,
      listUsers: [],
      currentRoutine: {},
      initalImage: null,
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    loadSettori() {
      let _ = this;
      _.isFetching = true;
      this.chiamataAxios("GET", "/auth/eventi/getGaraSettori/" + _.idGara).then(
        (response) => {
          // Aggiunge actions e icona validazione
          _.listSettori = response.data;
          _.isFetching = false;
          if (
            !_.selectedSettore ||
            !_.listSettori
              .map((settore) => {
                return settore.value;
              })
              .includes(_.selectedSettore)
          )
            if (!_.selectedSettore || !_.listSettori.map(settore => { return settore.value }).includes(_.selectedSettore)) _.selectedSettore = _.listSettori[0].value;
          _.loadGara();
        }
      );
    },
    goBack() {
      this.$router.push("/portal/eventi/listGare");
    },
    loadGara() {
      let _ = this;
      _.isFetching = true;

      let url = "/auth/eventi/getGara/" + _.idGara + "/" + _.selectedSettore;
      // Eventi aperti
      _.chiamataAxios("GET", url).then((response) => {
        _.tableData = response.data.dettaglio.routine.map((item) => {
          let listRoutine = item.partecipanti.map((routine) => {
            return routine.ordine;
          });

          item.listRoutine = listRoutine.join(", ");
          item.iconType = [];

          if (item.type === 'P') item.iconType.push(
            {
              icon: "mdi-counter",
              color: "green",
              text: _.$t("points"),
            })
          if (item.type === 'T') item.iconType.push(
            {
              icon: "mdi-timer-outline",
              color: "green",
              text: _.$t("time"),
            })
          if (item.mode === 'I') item.iconType.push(
            {
              icon: "mdi-account",
              color: "green",
              text: _.$t("individual"),
            })
          if (item.mode === 'D') item.iconType.push(
            {
              icon: "mdi-account-multiple",
              color: "green",
              text: _.$t("double"),
            })
          if (item.mode === 'T') item.iconType.push(
            {
              icon: "mdi-account-group",
              color: "green",
              text: _.$t("team"),
            })

          item.options = [
            {
              icon: "mdi-pencil",
              color: "secondary",
              text: _.$t("edit_category"),
              function: "editRoutine",
            },
            {
              icon: "mdi-content-copy",
              color: "secondary",
              text: _.$t("copy_category"),
              function: "editRoutine",
              parms: { copy: true },
            },
            {
              icon: "mdi-account-multiple",
              color: "secondary",
              text: _.$t("manage_subscribers"),
              function: "editGaraPartecipanti",
            },
          ];
          return item;
        });
      });
    },
    editGaraPartecipanti(item) {
      this.$router.push(
        "/portal/eventi/editGaraPartecipanti/" +
        this.idGara +
        "/" +
        item.idGareDettaglio
      );
    },

    editRoutine(item = false) {
      let _ = this;
      if (item) {
        _.method =
          !item || (item.callParms && item.callParms.copy) ? "ADD" : "EDIT";
        _.currentRoutine = Object.assign({}, item);
      } else {
        _.method = "ADD";
        _.currentRoutine = {};
      }
      this.$refs.editRoutineDialog.open();
    },
    deleteRoutine() {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "DELETE",
            "/auth/eventi/deleteRoutine/" +
            _.idGara +
            "/" +
            _.currentRoutine.idGareDettaglio
          ).then((resp) => {
            if (resp.msg.severity === 0) {
              let html = "<strong>" + resp.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadSettori();
              _.$refs.editRoutineDialog.close();
            }
          });
        }
      });
    },
    saveRoutine: function () {
      let _ = this;
      _.chiamataAxios(
        "PUT",
        "/auth/eventi/saveRoutine/" +
        _.idGara +
        "/" +
        (_.method === "EDIT" ? _.currentRoutine.idGareDettaglio : ""),
        { body: _.currentRoutine }
      ).then((resp) => {
        if (resp.msg.severity === 0) {
          let html = "<strong>" + resp.msg.msgTxt + "</strong>";
          Swal.fire({
            type: "success",
            html: html,
          });
          _.loadSettori();
          _.$refs.editRoutineDialog.close();
        }
      });
    },
  },
  computed: {},
  mounted() {
    let _ = this;
    _.listUsers = [];
    _.chiamataAxios("POST", "/auth/portal/listUsers").then((resp) => {
      _.listUsers = resp.data.map(function (item) {
        return {
          value: item.masterId,
          text:
            item.surname +
            " " +
            item.name +
            "   -   " +
            item.resCity +
            " (" +
            item.eta +
            " anni)",
        };
      });
    });
    _.listSchede = [];
    _.chiamataAxios("GET", "/auth/eventi/listSchedeValutazione").then(
      (response) => {
        _.listSchede = response.data.map((scheda) => {
          return { value: scheda.idScheda, text: scheda.nomeScheda };
        });
      }
    );

    this.loadSettori();
  },
  watch: {
    idGara: function (newVal, oldVal) {
      // watch it
      this.loadSettori();
    },
  },
};
</script>
